"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const [open, setOpen] = (0, react_1.useState)(false);
    const closeDialog = () => setOpen(false);
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog });
    (0, functions_1.useIOSDialogCloseScrollBack)(open);
    const { control } = (0, react_hook_form_1.useForm)({ mode: 'onChange', shouldUnregister: true });
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CommissionFeeButton, Object.assign({ onClick: () => setOpen(true) }, { children: t('수수료 5% 계산기') })), (0, jsx_runtime_1.jsxs)(CommissionFeeDialog, Object.assign({ open: open }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "contents_wrapper" }, { children: [(0, jsx_runtime_1.jsx)("h2", { children: t('수수료 안내') }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "commission_fees_grid" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "headers" }, { children: t('수수료') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "headers" }, { children: t('PG사 수수료') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "headers" }, { children: t('폰디 수수료') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "contents" }, { children: ["5%(", t('VAT별도'), ")"] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "contents", css: { rowGap: '6px' } }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "Paypal 4.4% + $0.3" }), (0, jsx_runtime_1.jsxs)("span", { children: [t('휴대폰'), " 4%"] }), (0, jsx_runtime_1.jsxs)("span", { children: [t('카드결제'), " 3.4%"] }), (0, jsx_runtime_1.jsxs)("span", { children: [t('계좌이체'), " 1.8%"] }), (0, jsx_runtime_1.jsxs)("span", { children: [t('가상계좌'), " 400", t('원')] }), (0, jsx_runtime_1.jsxs)("span", { children: ["(", t('VAT별도'), ")"] })] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "contents", css: { rowGap: '2px' } }, { children: [(0, jsx_runtime_1.jsx)("span", { children: t('폼 수수료에서 PG사 수수료를 제외한 나머지') }), (0, jsx_runtime_1.jsxs)("span", { children: ["*", t('10원 단위 절사된 잔액 포함')] })] }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', marginBottom: '30px' } }, { children: [(0, jsx_runtime_1.jsx)("h2", Object.assign({ css: { marginBottom: '10px' } }, { children: t('수수료 계산기') })), (0, jsx_runtime_1.jsx)(components_1.PriceCalculator, { wrapperStyle: {
                                            padding: '14px',
                                            '> input': { fontSize: '16px' },
                                            '> span': { fontSize: '14px !important' },
                                        }, name: "commissionFeeCalculator", control: control, defaultValue: 0 }), (0, jsx_runtime_1.jsx)("span", Object.assign({ css: { marginTop: '6px', lineHeight: '18px', fontSize: '14px' } }, { children: t('커미션이 종료되면 정산 받을 수 있어요.') }))] }))] })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, id: "confirm_btn_wrapper" }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "orange_filled", fullWidth: true, onClick: closeDialog }, { children: t('확인') })) }))] }))] }));
}
exports.default = default_1;
const CommissionFeeButton = (0, styled_1.default)(Button_1.default) `
  align-self: flex-end;
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.8);
  background-color: white !important;
  color: rgba(0, 0, 0, 0.8);
  font-size: 15px;
  font-weight: bold;
`;
const CommissionFeeDialog = (0, styled_1.default)(Dialog_1.default) `
  .MuiDialog-scrollPaper {
    align-items: flex-end;
  }
  .MuiDialog-paper {
    width: 100%;
    max-width: 480px;
    padding: 20px 16px;
    border-radius: 24px 24px 0 0;
    margin: 0;
    color: rgba(0, 0, 0, 0.8);
    overflow: hidden;
  }
  #contents_wrapper {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    height: 100%;
    padding: 0px 16px;
    margin: 0 -16px -20px;
    overflow: hidden auto;
    h2 {
      line-height: 24px;
      font-size: 20px;
      font-weight: bold;
    }
    #commission_fees_grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 1px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      background-color: rgba(0, 0, 0, 0.1);
      > div {
        line-height: 20px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 10px;
        color: rgba(0, 0, 0, 0.8);
        span {
          text-align: center;
          line-height: 20px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.8);
          word-break: keep-all;
        }
      }
      .headers {
        font-weight: bold;
        background-color: #f8f8f8;
      }
      .contents {
        background-color: white;
      }
    }
  }
  #confirm_btn_wrapper {
    position: sticky;
    bottom: 0;
    padding: 20px 0;
  }
  button {
    height: 48px;
    border-radius: 8px;
  }
`;
